export default "__VITE_ASSET__c6e86130__"